import linkifyIt from 'linkify-it';
import type { Match } from 'linkify-it';

import type { ArticleNode } from '../helpers';

import { formatHref, splitTextByLinks, truncateText } from '.';

// TODO: use "@xing-com/crate-components-text-linkifier" once content-editor is fully in crate
export const linkifyText = (node: ArticleNode): ArticleNode[] => {
  if (!node?.text) return [node];

  const { text, ...restProps } = node;

  const matches: Match[] | null = linkifyIt().match(text);
  if (!matches?.length) return [{ text, ...restProps }];

  const linksInText = matches?.map(({ raw }) => raw);

  return splitTextByLinks(text, linksInText).map((subString) =>
    linksInText.includes(subString)
      ? {
          type: 'link',
          data: { href: formatHref(subString) },
          children: [{ text: truncateText(subString), ...restProps }],
        }
      : { text: subString, ...restProps }
  );
};
